import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LifeInsurancePlan extends Enum {
  static INDIVIDUAL_PLAN = {
    key: 'individual_plan',
    get value() {
      return Lang.t('asset.individual-plan');
    }
  };

  static GROUP_PLAN = {
    key: 'group_plan',
    get value() {
      return Lang.t('asset.group-plan');
    }
  };
}
